<template>
  <div>
    <!-- Botão da IA Assistente -->
    <div
      class="dropdown d-inline-block ai-chat-dropdown enhanced-ai-chat"
      v-if="width >= 500"
    >
      <a
        type="button"
        :class="['ai-chat-menu enhanced-ai-btn', { 'chat-open': showAIChat }]"
        @click="toggleAIChat"
      >
        <img
          :src="require('../../assets/sistemaclinai.webp')"
          class="sistemaclin-ai"
          alt="SistemaClin AI"
        />
      </a>
    </div>

    <!-- Modal da IA Chat -->
    <div v-if="showAIChat" class="ai-chat-overlay">
      <div class="ai-chat-modal" @click.stop>
        <div class="ai-chat-header">
          <div class="ai-chat-title">
            <img
              :src="require('../../assets/sistemaclinai.webp')"
              class="sistemaclin-ai-icon mr-2"
              alt="SistemaClin AI"
            />
            Assistente de IA
          </div>
          <button class="ai-chat-close" @click="toggleAIChat">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="ai-chat-body">
          <!-- Histórico de conversas -->
          <div class="ai-chat-messages" ref="messagesContainer">
            <div v-if="chatHistory.length == 0" class="ai-chat-welcome">
              <div class="welcome-header">
                <img
                  :src="require('../../assets/logo.png')"
                  class="sistemaclin-logo mr-2"
                  alt="SistemaClin AI"
                />
                <img
                  :src="require('../../assets/sistemaclinai.webp')"
                  class="sistemaclin-ai-icon"
                  alt="SistemaClin AI"
                />
              </div>

              <h3 class="welcome-title">Olá! Como posso ajudar?</h3>
              <p class="welcome-subtitle">
                Seu assistente para consultas sobre residentes
              </p>

              <!-- Funcionalidades Disponíveis -->
              <div class="ai-features-grid">
                <div class="ai-feature-card">
                  <div class="feature-icon prescription-icon">
                    <i class="fas fa-prescription-bottle-alt"></i>
                  </div>
                  <h4 class="feature-title">Prescrições</h4>
                  <p class="feature-description">
                    Consulte prescrições médicas dos residentes
                  </p>
                </div>

                <div class="ai-feature-card">
                  <div class="feature-icon vitals-icon">
                    <i class="fas fa-heartbeat"></i>
                  </div>
                  <h4 class="feature-title">Sinais Vitais</h4>
                  <p class="feature-description">
                    Analise os sinais vitais registrados
                  </p>
                </div>

                <div class="ai-feature-card">
                  <div class="feature-icon contracts-icon">
                    <i class="fas fa-calendar-times"></i>
                  </div>
                  <h4 class="feature-title">Contratos</h4>
                  <p class="feature-description">
                    Verifique contratos com vencimento próximo
                  </p>
                </div>

                <div class="ai-feature-card">
                  <div class="feature-icon prescription-icon">
                    <i class="fas fa-capsules"></i>
                  </div>
                  <h4 class="feature-title">
                    Medicamentos - Análise terapêutica
                  </h4>
                  <MedicineAnalyzer />
                </div>
              </div>

              <!-- Exemplos de Perguntas -->
              <div class="ai-examples-section">
                <h4 class="examples-title">
                  <i class="fas fa-lightbulb mr-2"></i>
                  Exemplos de perguntas:
                </h4>
                <div class="examples-list">
                  <div
                    class="example-item"
                    @click="setExampleMessage('Qual a prescrição da Maria')"
                  >
                    <i class="fas fa-quote-left example-icon"></i>
                    <span class="example-text">Qual a prescrição da Maria</span>
                  </div>
                  <div
                    class="example-item"
                    @click="
                      setExampleMessage('Quais os sinais vitais da Maria')
                    "
                  >
                    <i class="fas fa-quote-left example-icon"></i>
                    <span class="example-text"
                      >Quais os sinais vitais da Maria</span
                    >
                  </div>
                  <div
                    class="example-item"
                    @click="
                      setExampleMessage(
                        'Quem está com contrato vencendo daqui 1 mês'
                      )
                    "
                  >
                    <i class="fas fa-quote-left example-icon"></i>
                    <span class="example-text"
                      >Quem está com contrato vencendo daqui 1 mês</span
                    >
                  </div>
                </div>
              </div>

              <!-- Dica de Uso -->
              <div class="ai-usage-tip">
                <div class="tip-icon">
                  <i class="fas fa-info-circle"></i>
                </div>
                <div class="tip-content">
                  <strong>Dica:</strong> Seja específico com o nome do residente
                  para obter resultados mais precisos.
                </div>
              </div>
            </div>

            <div v-else>
              <div
                v-for="(message, index) in chatHistory"
                :key="index"
                :class="[
                  'ai-message',
                  message.sender === 'user'
                    ? 'user-message'
                    : 'ai-message-item',
                ]"
              >
                <div class="message-avatar">
                  <img
                    v-if="message.sender != 'user'"
                    :src="require('../../assets/sistemaclinai.webp')"
                    class="sistemaclin-ai-icon"
                  />
                  <img
                    v-if="message.sender == 'user' && !photo_url"
                    :src="require('../../assets/user.png')"
                    class="user-icon-photo-url"
                  />
                  <img
                    v-if="message.sender == 'user' && photo_url"
                    :src="photo_url"
                    class="user-icon-photo-url"
                  />
                  <div v-if="message.sender == 'user'" class="message-time">
                    {{ formatMessageTime(message.timestamp) }}
                  </div>
                </div>
                <div class="message-content">
                  <div
                    class="message-text"
                    v-html="formatAIResponse(message.text)"
                  ></div>
                  <div v-if="message.sender != 'user'" class="message-time">
                    {{ formatMessageTime(message.timestamp) }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Indicador de digitação -->
            <div
              v-if="isTyping"
              class="ai-message ai-message-item typing-indicator"
            >
              <div class="message-avatar">
                <img
                  :src="require('../../assets/sistemaclinai.webp')"
                  class="sistemaclin-ai-icon"
                  alt="SistemaClin AI"
                />
              </div>
              <div class="message-content">
                <div class="typing-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <!-- Área de input -->
          <div class="ai-chat-input-area">
            <div class="row">
              <div class="col-md-12">
                <div class="input-wrapper">
                  <textarea
                    v-model="userMessage"
                    class="ai-input form-control"
                    :placeholder="inputPlaceholder"
                    rows="2"
                    @keypress.enter="handleEnter"
                    @keydown.shift.enter="handleShiftEnter"
                    :disabled="isTyping"
                    ref="messageInput"
                  ></textarea>
                  <div v-if="userMessage.length > 0" class="input-counter">
                    {{ userMessage.length }}/500
                  </div>
                </div>
              </div>
              <div
                class="col-md-12 text-right d-flex align-items-center justify-content-between mt-2"
              >
                <button
                  class="btn-modern btn-clear-ai-chat"
                  @click="clearAIChat"
                  :disabled="isTyping"
                >
                  <i class="fas fa-times mr-1"></i>
                  Limpar conversa
                </button>
                <div class="input-hints mr-2">
                  <span class="hint-text">
                    <i class="fas fa-keyboard mr-1"></i>
                    Enter para enviar, Shift+Enter para quebrar linha
                  </span>
                </div>
                <div class="input-actions">
                  <ChromeSpeech v-model="userMessage" class="mr-2" />
                  <button
                    class="btn-modern btn-modern-save"
                    @click="sendMessage"
                    :disabled="
                      !userMessage.trim() ||
                      isTyping ||
                      userMessage.length > 500
                    "
                  >
                    <i class="fas fa-paper-plane mr-1"></i>
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChromeSpeech from "../Components/ChromeSpeech";
import MedicineAnalyzer from "../AI/MedicineAnalyzer";
import { userData } from "../../lib/functions";
import api from "../../services/api";
import moment from "moment";

export default {
  name: "GoogleGeminiChatAI",

  components: {
    ChromeSpeech,
    MedicineAnalyzer,
  },

  data() {
    return {
      width: window.screen.width,
      photo_url: null,
      showAIChat: false,
      userMessage: "",
      chatHistory: [],
      isTyping: false,
    };
  },

  computed: {
    inputPlaceholder() {
      const placeholders = [
        "Digite sua pergunta sobre residentes...",
        "Ex: Qual a prescrição da Maria?",
        "Ex: Quais os sinais vitais do João?",
        "Ex: Contratos vencendo em 30 dias?",
      ];

      return this.chatHistory.length > 0
        ? placeholders[0]
        : placeholders[Math.floor(Math.random() * placeholders.length)];
    },
  },

  created() {
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
    let { photo_url } = userData().user;
    this.photo_url = photo_url;
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    handleOnResize() {
      this.width = window.innerWidth;
    },

    // Métodos da IA Chat
    clearAIChat() {
      this.chatHistory = [];
      this.userMessage = "";

      if (this.showAIChat) {
        this.$nextTick(() => {
          this.$refs.messageInput?.focus();
        });
      }
    },

    toggleAIChat() {
      this.chatHistory = [];
      this.userMessage = "";
      this.showAIChat = !this.showAIChat;

      if (this.showAIChat) {
        this.$nextTick(() => {
          this.$refs.messageInput?.focus();
        });
      }
    },

    setExampleMessage(message) {
      this.userMessage = message;
      this.$nextTick(() => {
        this.$refs.messageInput?.focus();
      });
    },

    handleShiftEnter() {
      // Permite quebra de linha com Shift+Enter
      return;
    },

    handleEnter(event) {
      // Se não for Shift+Enter, envia a mensagem
      if (!event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    },

    formatMessageTime(timestamp) {
      return moment(timestamp).format("HH:mm");
    },

    formatAIResponse(text) {
      if (!text) return "";

      // Converte markdown básico para HTML
      let formattedText = text
        // Converte **texto** para <strong>texto</strong>
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        // Converte *texto* para <em>texto</em>
        .replace(/\*(.*?)\*/g, "<em>$1</em>")
        // Converte quebras de linha para <br>
        .replace(/\n/g, "<br>")
        // Converte listas numeradas
        .replace(/^(\d+\.\s+.*?)$/gm, '<div class="ai-numbered-item">$1</div>')
        // Converte listas com bullets (*   )
        .replace(/^\*\s+(.+)$/gm, '<div class="ai-bullet-item">• $1</div>')
        // Converte sub-itens indentados
        .replace(/^(\s{4,})\*\s+(.+)$/gm, '<div class="ai-sub-item">◦ $2</div>')
        // Converte títulos com ###
        .replace(/^###\s+(.+)$/gm, '<h4 class="ai-subtitle">$1</h4>')
        // Converte títulos com ##
        .replace(/^##\s+(.+)$/gm, '<h3 class="ai-title">$1</h3>');

      return formattedText;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    async sendMessage() {
      if (
        !this.userMessage.trim() ||
        this.isTyping ||
        this.userMessage.length > 500
      )
        return;

      const message = this.userMessage.trim();
      this.userMessage = "";

      // Se é a primeira mensagem, limpa o estado de boas-vindas
      if (this.chatHistory.length === 0) {
        // Adiciona uma pequena animação de saída para as boas-vindas
        const welcomeElement = document.querySelector(".ai-chat-welcome");
        if (welcomeElement) {
          welcomeElement.style.opacity = "0";
          welcomeElement.style.transform = "translateY(-10px)";
        }
      }

      // Adiciona mensagem do usuário
      this.chatHistory.push({
        sender: "user",
        text: message,
        timestamp: new Date(),
      });

      this.scrollToBottom();
      this.isTyping = true;

      try {
        // Chama a API da IA
        const response = await this.callAIAPI(message);

        // Adiciona resposta da IA
        this.chatHistory.push({
          sender: "ai",
          text: response,
          timestamp: new Date(),
        });
      } catch (error) {
        console.error("Erro ao comunicar com IA:", error);

        // Mensagem de erro mais amigável
        this.chatHistory.push({
          sender: "ai",
          text: "😔 Ops! Tive um problema para processar sua solicitação. Verifique se:\n\n• O nome do residente está correto\n• A pergunta está clara\n• Sua conexão está estável\n\nTente novamente com uma pergunta mais específica.",
          timestamp: new Date(),
        });
      } finally {
        this.isTyping = false;
        this.scrollToBottom();
        this.$nextTick(() => {
          this.$refs.messageInput?.focus();
        });
      }
    },

    async callAIAPI(message) {
      try {
        const responseAi = await api.post("/ai/chat", { message });
        let { response } = responseAi.data;
        return response;
      } catch (error) {
        console.error("Erro na chamada da API:", error);
        throw error;
      }
    },
  },
};
</script>

<style scoped>
/* Botão da IA - Simplificado para Performance */
.enhanced-ai-chat {
  position: relative !important;
}

.enhanced-ai-btn {
  width: 42px !important;
  height: 42px !important;
  border-radius: 50% !important;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  position: relative !important;
  box-shadow: 0 2px 8px rgba(31, 127, 211, 0.3) !important;
}

.enhanced-ai-btn:hover {
  transform: scale(1.05) !important;
  color: white !important;
  text-decoration: none !important;
  box-shadow: 0 4px 12px rgba(31, 127, 211, 0.4) !important;
}

.sistemaclin-ai {
  width: 28px !important;
  height: 28px !important;
  object-fit: contain !important;
  transition: transform 0.2s ease !important;
}

.enhanced-ai-btn:hover .sistemaclin-ai {
  transform: rotate(15deg) !important;
}

.chat-open {
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
}

.chat-open:hover {
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

/* Modal da IA Chat */
.ai-chat-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ai-chat-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.2s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Cabeçalho do Modal */
.ai-chat-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ai-chat-title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.ai-chat-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-chat-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

/* Corpo do Modal */
.ai-chat-body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 200px);
  max-height: 600px;
}

/* Tela de Boas-vindas */
.ai-chat-welcome {
  padding: 16px 12px;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  margin: 20px;
  transition: all 0.3s ease;
}

.welcome-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 10px;
}

.sistemaclin-logo {
  width: 200px;
  object-fit: contain;
}

.sistemaclin-ai-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 8px;
}

.welcome-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.welcome-subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  margin-bottom: 10px;
}

/* Grid de Funcionalidades */
.ai-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.ai-feature-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 10px 8px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: default;
}

.ai-feature-card:hover {
  border-color: #0f65b0;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(15, 101, 176, 0.1);
}

.feature-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 12px;
  color: white;
}

.prescription-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.vitals-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.contracts-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.feature-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.feature-description {
  font-size: 12px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}

/* Seção de Exemplos */
.ai-examples-section {
  margin-bottom: 24px;
}

.examples-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.examples-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.example-item {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.example-item:hover {
  border-color: #0f65b0;
  background: #f8fafc;
  transform: translateX(4px);
}

.example-icon {
  color: #0f65b0;
  font-size: 12px;
  opacity: 0.7;
}

.example-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* Dica de Uso */
.ai-usage-tip {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border: 1px solid #60a5fa;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.tip-icon {
  color: #2563eb;
  font-size: 16px;
  margin-top: 2px;
}

.tip-content {
  font-size: 13px;
  color: #1e40af;
  line-height: 1.4;
}

/* Área de mensagens quando há histórico */
.ai-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f8fafc;
  min-height: 300px;
}

/* Mensagem individual */
.ai-message {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  animation: messageSlide 0.2s ease;
}

@keyframes messageSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-message {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-icon-photo-url {
  width: 40px !important;
  height: 40px !important;
  border-radius: 8px !important;
  object-fit: cover !important;
}

.message-content {
  flex: 1;
  max-width: 75%;
  margin-top: 2px;
}

.message-text {
  background: white;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  word-wrap: break-word;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.user-message .message-text {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-color: #1e40af;
}

.message-time {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 4px;
}

.user-message .message-time {
  text-align: right;
}

/* Indicador de digitação */
.typing-indicator .message-text {
  background: white;
  border: 1px solid #e5e7eb;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.typing-dots {
  display: flex;
  gap: 4px;
}

.typing-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9ca3af;
  animation: typing 1.2s infinite ease-in-out;
}

.typing-dots span:nth-child(1) {
  animation-delay: 0s;
}
.typing-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%,
  80%,
  100% {
    opacity: 0.5;
    transform: scale(1);
  }
  40% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* Área de input */
.ai-chat-input-area {
  border-top: 1px solid #e5e7eb;
  padding: 16px 20px;
  background: white;
}

.input-wrapper {
  position: relative;
}

.ai-input {
  flex: 1;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  transition: all 0.2s ease;
  background: #f8fafc;
  min-height: 44px;
}

.ai-input:focus {
  outline: none;
  border-color: #0f65b0;
  background: white;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.ai-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.input-counter {
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 11px;
  color: #9ca3af;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 6px;
  border-radius: 4px;
}

.input-hints {
  flex: 1;
}

.hint-text {
  font-size: 11px;
  color: #9ca3af;
}

.input-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Estilos para formatação da resposta da IA */
.message-text .ai-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  margin: 12px 0 8px 0;
  border-bottom: 2px solid #10b981;
  padding-bottom: 4px;
}

.message-text .ai-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 10px 0 6px 0;
}

.message-text .ai-numbered-item {
  margin: 8px 0;
  padding-left: 8px;
  font-weight: 600;
  color: #1f2937;
}

.message-text .ai-bullet-item {
  margin: 6px 0;
  padding-left: 12px;
  color: #374151;
}

.message-text .ai-sub-item {
  margin: 4px 0;
  padding-left: 24px;
  color: #6b7280;
  font-size: 13px;
}

.user-message .message-text .ai-title,
.user-message .message-text .ai-subtitle,
.user-message .message-text .ai-numbered-item,
.user-message .message-text .ai-bullet-item,
.user-message .message-text .ai-sub-item {
  color: white;
}

.user-message .message-text .ai-title {
  border-bottom-color: rgba(255, 255, 255, 0.5);
}

/* Scrollbar personalizada */
.ai-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.ai-chat-messages::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.ai-chat-messages::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.ai-chat-messages::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.btn-clear-ai-chat {
  background-color: #d3d3d3;
  color: #525151;
}

/* Responsividade */
@media (max-width: 768px) {
  .enhanced-ai-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .sistemaclin-ai {
    width: 24px !important;
    height: 24px !important;
  }

  .ai-chat-modal {
    width: 95%;
    height: 90vh;
    max-height: none;
  }

  .ai-chat-body {
    height: calc(100vh - 140px);
    max-height: none;
  }

  .ai-chat-welcome {
    padding: 24px 16px;
    margin: 16px;
  }

  .welcome-title {
    font-size: 20px;
  }

  .ai-features-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .ai-feature-card {
    padding: 16px 12px;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .message-content {
    max-width: 85%;
  }

  .ai-chat-messages {
    padding: 16px;
    gap: 12px;
    min-height: 200px;
  }

  .message-avatar {
    width: 32px;
    height: 32px;
  }

  .sistemaclin-ai-icon {
    width: 32px;
    height: 32px;
  }

  .user-icon-photo-url {
    width: 32px !important;
    height: 32px !important;
  }

  .input-hints {
    display: none;
  }

  .ai-chat-input-area {
    padding: 12px;
  }
}

@media (max-width: 576px) {
  .ai-chat-modal {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }

  .welcome-header {
    flex-direction: column;
    gap: 12px;
  }

  .sistemaclin-logo {
    width: 100px;
  }

  .examples-list {
    gap: 6px;
  }

  .example-item {
    padding: 10px 12px;
  }

  .example-text {
    font-size: 13px;
  }
}
</style>